<template>
  <v-layout>
    <MainMenu />
    <v-flex>
      <v-layout
        align-space-between
        justify-start
        column
        fill-height
      >
        <ListPagesHeader
          :page-title="$t('warehouses.title')"
          :show-btn="false"
          class="none-growth"
        />
        <v-layout
          v-if="isLoading === false"
          class="page-content-paddings"
          wrap
          column
          none-growth
        >
          <v-layout
            justify-center
            wrap
          >
            <v-flex
              order-xs2
              order-lg1
            >
              <WarehouseFilters
                v-if="!showInfo"
                @filtered="filtered($event)"
              />
            </v-flex>
            <v-flex
              order-xs1
              order-lg2
            >
              <v-layout
                :justify-center="$vuetify.breakpoint.smAndDown"
                :justify-end="$vuetify.breakpoint.mdAndUp"
                wrap
              >
                <AddWarehouseButton
                  v-if="canCreateRegionWarehouse"
                  :warehouse-type="warehouseType.REGIONAL"
                  :class="[{ 'mr-4': $vuetify.breakpoint.mdAndUp }]"
                />
                <AddWarehouseButton
                  v-if="canCreateSupportingWarehouse"
                  :warehouse-type="warehouseType.SUPPORTING"
                />
              </v-layout>
            </v-flex>
          </v-layout>
          <AddWarehouseInfo
            v-if="showInfo"
            :warehouse-type="currentWarehouseType"
          />
          <WarehousesList
            v-else
            :is-loading="isListLoading"
            @pagination="fetchAvailableWarehouses"
          />
        </v-layout>
        <PageLoader v-else />
        <v-layout align-end>
          <v-flex class="footer-wrap">
            <div class="page-content-paddings">
              <AppFooter class="mb-3" />
            </div>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import ListPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import PageLoader from '@/components/widgets/PageLoader';
import AddWarehouseButton from '@/components/widgets/warehouse/AddWarehouseButton';
import WarehousesList from '@/components/warehouse/WarehousesList';
import AddWarehouseInfo from '@/components/warehouse/AddWarehouseInfo';
import WarehouseFilters from '@/components/warehouse/warehousesList/WarehouseFilters';
import AppFooter from '@/components/widgets/AppFooter';

import TYPES from '@/constants/warehouse/warehouseType';
import permissions from '@/constants/permissions';

export default {
    name: 'WarehouseList',
    components: {
        AddWarehouseInfo,
        AppFooter,
        WarehousesList,
        AddWarehouseButton,
        PageLoader,
        ListPagesHeader,
        MainMenu,
        WarehouseFilters
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            const warehouseRoutes = ['warehouse-data', 'supporting-warehouse-data', 'warehouse-card'];
            if (!warehouseRoutes.includes(from.name)) {
                vm.$store.commit('warehouses/clearPagination');
            }

            vm.$store
                .dispatch('warehouses/getAllAvailableWarehouses')
                .then(({ data }) => {
                    vm.showInfo = data.data.amount === 0;
                })
                .finally(() => {
                    if (vm.showInfo) {
                        vm.$store.dispatch('warehouses/loadResource', 3).finally(() => {
                            vm.isLoading = false;
                        });
                    } else {
                        vm.isLoading = false;
                    }
                });
        });
    },
    data () {
        return {
            isLoading: null,
            isListLoading: null,
            warehouseType: TYPES,
            permissions,
            canCreateRegionWarehouse: null,
            canCreateSupportingWarehouse: null,
            showInfo: false
        };
    },
    computed: {
        canCreateWarehouse () {
            return this.canCreateRegionWarehouse || this.canCreateSupportingWarehouse;
        },
        warehouses () {
            return this.$store.getters['warehouses/getAvailableWarehouses'];
        },
        currentWarehouseType () {
            if (this.showInfo) {
                if (this.canCreateRegionWarehouse) {
                    if (this.canCreateSupportingWarehouse) {
                        return this.warehouseType.BOTH;
                    }
                    return this.warehouseType.REGIONAL;
                } else if (this.canCreateSupportingWarehouse) {
                    return this.warehouseType.SUPPORTING;
                }
                return this.warehouseType.NOTHING;
            }
            return null;
        }
    },
    async created () {
        this.canCreateRegionWarehouse = await this.$store.dispatch(
            'auth/hasPermission',
            this.permissions.ADD_REGIONAL_WAREHOUSE
        );
        this.canCreateSupportingWarehouse = await this.$store.dispatch(
            'auth/hasPermission',
            this.permissions.ADD_SUPPORTING_WAREHOUSE
        );
        if (this.canCreateWarehouse) {
            await this.$store.dispatch('defaultApi/getAvailableWioStructs');
        }
    },
    methods: {
        fetchAvailableWarehouses () {
            this.isListLoading = true;
            this.$store.commit('warehouses/setAvailableWarehouses', []);
            this.$store.dispatch('warehouses/getAllAvailableWarehouses').finally(() => {
                this.isListLoading = false;
            });
        },
        filtered (event) {
            this.$store.commit('warehouses/setPagination', { filtersParams: event });
            this.fetchAvailableWarehouses();
        }
    }
};
</script>

<style scoped></style>
